var globalConfigVariables = {
    // apiDomain: '/api/v1/',
    apiDomain: 'http://timesheet.growthopsapp.com/api/v1/'
}

//http://cms.timesheet.apdsecureapp.com/api/v1/

export default globalConfigVariables